import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';

export default function StationTrainingTable({ title, countLabel, records }) {
  return (
    <div className="people-station-table-wrapper" style={{ borderRadius: 6, padding: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
        <h4 className="people-station-table-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>
          {title}
        </h4>
        <span className="people-mock-badge" style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10 }}>
          Mock data
        </span>
      </div>
      <div className="people-count-line" style={{ fontSize: 13, marginBottom: 12 }}>
        <strong>{records.length}</strong> {countLabel}
      </div>
      <Table striped bordered hover size="sm" responsive>
        <thead>
          <tr>
            <th>Operator Name</th>
            <th>Station</th>
          </tr>
        </thead>
        <tbody>
          {records.length > 0 ? (
            records.map(r => (
              <tr key={r.userId}>
                <td>{r.userName}</td>
                <td>{r.stationName}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={2} className="text-center text-muted">
                No records for this date.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

StationTrainingTable.propTypes = {
  title: PropTypes.string.isRequired,
  countLabel: PropTypes.string.isRequired,
  records: PropTypes.array.isRequired
};
